import React, { useEffect } from 'react';
import InputWrapper from '../../../../../common/InputWrapper';
import Checkbox from '../../../../../common/Checkbox';
import {
  DefaultVatSelect,
  DeliveryContractSelect,
  ProductPriceTypeSelect,
  WarehouseNameSelect,
} from './FormSelects';
import Button from '../../../../../common/Button';
import { useDispatch } from 'react-redux';
import {
  fetchGetEshopPriceType,
  fetchGetEshopTokenAliexpress,
} from '../../../../../../actions/admin';
import { TAB_MODS } from '../../../../../../config/mods';
import { toast } from 'react-toastify';
import AdditionalForm from './AdditionalForm';

const displayFieldsByMarketplaceType = (marketplaceType, values, setFieldValue, mode) => {
  switch (marketplaceType) {
    case 'ALIEXPRESS':
      return <AliexpressFields values={values} setFieldValue={setFieldValue} mode={mode} />;
    case 'AVITO':
      return <AvitoFields values={values} setFieldValue={setFieldValue} />;
    case 'BERU':
      return <BeruFields values={values} setFieldValue={setFieldValue} />;
    // case 'KASPI':
    //   return <KaspiFields values={values} setFieldValue={setFieldValue} />;
    case 'OZON':
      return <OzonFields values={values} setFieldValue={setFieldValue} />;
    case 'WILDBERRIES':
      return <WBFields values={values} setFieldValue={setFieldValue} />;
    default:
      return <DefaultFields values={values} setFieldValue={setFieldValue} />;
  }
};

export const MainMarketplacesForm = React.memo(
  ({ values, setFieldValue, marketplaceType, mode }) => {
    return (
      <>
        {
          mode === 'ADD' ? (
            <MinimumRequiredFieldsToCreateMarketplace
              values={values}
              setFieldValue={setFieldValue}
            /> //* form with minimal fields just to create eshop
          ) : (
            displayFieldsByMarketplaceType(marketplaceType, values, setFieldValue, mode)
          ) //* ...then form to show/edit previously created eshop by its type (mode === 'EDIT')
        }
      </>
    );
  },
);

const MinimumRequiredFieldsToCreateMarketplace = ({ values, setFieldValue }) => {
  return (
    <>
      <div className="col-12 mt-2">
        <Checkbox
          id="isActive"
          label="Активен"
          checked={values?.isActive}
          values={values?.isActive}
          onChange={(e) => setFieldValue('isActive', !values.isActive)}
        />
      </div>
      <div className="col-12 mt-2">
        <InputWrapper
          id="name"
          label="Название магазина"
          value={values?.name}
          onChange={(e) => setFieldValue('name', e.target.value)}
        />
      </div>
      <WarehouseNameSelect value={values?.warehouse} setFieldValue={setFieldValue} />
    </>
  );
};

const DefaultFields = ({ values, setFieldValue }) => (
  <>
    <MinimumRequiredFieldsToCreateMarketplace values={values} setFieldValue={setFieldValue} />
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiLogin"
        label="Логин"
        value={values?.apiLogin}
        onChange={(e) => setFieldValue('apiLogin', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiPassword"
        label="Пароль"
        value={values?.apiPassword}
        onChange={(e) => setFieldValue('apiPassword', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiToken"
        label="Токен"
        value={values?.apiToken}
        onChange={(e) => setFieldValue('apiToken', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="extId"
        label="Внешний код"
        value={values?.extId}
        onChange={(e) => setFieldValue('extId', e.target.value)}
      />
    </div>
    <ProductPriceTypeSelect
      id="priceType"
      label="Цена товара после скидки"
      value={values?.priceType}
      setFieldValue={setFieldValue}
    />
    <ProductPriceTypeSelect
      id="prevPriceType"
      label="Цена товара до скидки"
      value={values?.prevPriceType}
      setFieldValue={setFieldValue}
    />
    <div className="col-12 mt-2">
      <InputWrapper
        id="percentStock"
        label="Процент остатков к выгрузке"
        value={values?.percentStock}
        onChange={(e) => setFieldValue('percentStock', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="orderTag"
        label="Метка на заказы"
        value={values?.orderTag}
        onChange={(e) => setFieldValue('orderTag', e.target.value)}
      />
    </div>
    <DeliveryContractSelect value={values?.deliveryInfo} setFieldValue={setFieldValue} />
  </>
);

const AliexpressFields = ({ values, setFieldValue, mode }) => {
  const dispatch = useDispatch();

  const getEshopAliexpressToken = async () => {
    try {
      const res = await dispatch(fetchGetEshopTokenAliexpress(values.code));
      if (res.success) {
        setFieldValue('apiToken', res.url);
      }
    } catch (error) {
      toast.error('Ошибка при получении токена!');
    }
  };

  return (
    <>
      <MinimumRequiredFieldsToCreateMarketplace values={values} setFieldValue={setFieldValue} />
      <div className="col-12 mt-2">
        <InputWrapper
          id="apiToken"
          label="Токен"
          value={values?.apiToken}
          onChange={(e) => setFieldValue('apiToken', e.target.value)}
        />
      </div>
      <div className="mt-2">
        <Button text="Получить токен" onClick={getEshopAliexpressToken} />
      </div>
      <ProductPriceTypeSelect
        id="priceType"
        label="Цена товара после скидки"
        value={values?.priceType}
        setFieldValue={setFieldValue}
      />
      <ProductPriceTypeSelect
        id="prevPriceType"
        label="Цена товара до скидки"
        value={values?.prevPriceType}
        setFieldValue={setFieldValue}
      />
      <div className="col-12 mt-2">
        <InputWrapper
          id="percentStock"
          label="Процент остатков к выгрузке"
          value={values?.percentStock}
          onChange={(e) => setFieldValue('percentStock', e.target.value)}
        />
      </div>
      <div className="col-12 mt-2">
        <InputWrapper
          id="orderTag"
          label="Метка на заказы"
          value={values?.orderTag}
          onChange={(e) => setFieldValue('orderTag', e.target.value)}
        />
      </div>
      <DeliveryContractSelect value={values?.deliveryInfo} setFieldValue={setFieldValue} />
    </>
  );
};

const AvitoFields = ({ values, setFieldValue }) => (
  <>
    <MinimumRequiredFieldsToCreateMarketplace values={values} setFieldValue={setFieldValue} />
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiLogin"
        label="Client ID"
        value={values?.apiLogin}
        onChange={(e) => setFieldValue('apiLogin', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiPassword"
        label="Client_secret"
        value={values?.apiPassword}
        onChange={(e) => setFieldValue('apiPassword', e.target.value)}
      />
    </div>
    <ProductPriceTypeSelect
      id="priceType"
      label="Цена товара после скидки"
      value={values?.priceType}
      setFieldValue={setFieldValue}
    />
    <ProductPriceTypeSelect
      id="prevPriceType"
      label="Цена товара до скидки"
      value={values?.prevPriceType}
      setFieldValue={setFieldValue}
    />
    <div className="col-12 mt-2">
      <InputWrapper
        id="percentStock"
        label="Процент остатков к выгрузке"
        value={values?.percentStock}
        onChange={(e) => setFieldValue('percentStock', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="orderTag"
        label="Метка на заказы"
        value={values?.orderTag}
        onChange={(e) => setFieldValue('orderTag', e.target.value)}
      />
    </div>
    <DeliveryContractSelect value={values?.deliveryInfo} setFieldValue={setFieldValue} />
  </>
);

const BeruFields = ({ values, setFieldValue }) => (
  <>
    <MinimumRequiredFieldsToCreateMarketplace values={values} setFieldValue={setFieldValue} />
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiUrl"
        label="Адрес API"
        value={values?.apiUrl}
        onChange={(e) => setFieldValue('apiUrl', e.target.value)}
        isDisabled={true}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiLogin"
        label="Client ID"
        value={values?.apiLogin}
        onChange={(e) => setFieldValue('apiLogin', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiPassword"
        label="Отладочный токен доступа"
        value={values?.apiPassword}
        onChange={(e) => setFieldValue('apiPassword', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiToken"
        label="Авторизационный токен"
        value={values?.apiToken}
        onChange={(e) => setFieldValue('apiToken', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="extId"
        label="ID Кампании (Внешний код)"
        value={values?.extId}
        onChange={(e) => setFieldValue('extId', e.target.value)}
      />
    </div>
    <DefaultVatSelect defaultVat={values?.defaultVat} setFieldValue={setFieldValue} />
    <ProductPriceTypeSelect
      id="priceType"
      label="Цена товара после скидки"
      value={values?.priceType}
      setFieldValue={setFieldValue}
    />
    <ProductPriceTypeSelect
      id="prevPriceType"
      label="Цена товара до скидки"
      value={values?.prevPriceType}
      setFieldValue={setFieldValue}
    />
    <div className="col-12 mt-2">
      <InputWrapper
        id="percentStock"
        label="Процент остатков к выгрузке"
        value={values?.percentStock}
        onChange={(e) => setFieldValue('percentStock', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="orderTag"
        label="Метка на заказы"
        value={values?.orderTag}
        onChange={(e) => setFieldValue('orderTag', e.target.value)}
      />
    </div>
    <DeliveryContractSelect value={values?.deliveryInfo} setFieldValue={setFieldValue} />
  </>
);

// const KaspiFields = ({ values, setFieldValue }) => (
//   <>
//     <div className="col-12 mt-2">
//       <Checkbox
//         id="isActive"
//         label="Активен"
//         values={values?.isActive}
//         onChange={(e) => setFieldValue('isActive', !values.isActive)}
//       />
//     </div>
//     <div className="col-12 mt-2">
//       <InputWrapper
//         id="name"
//         label="Название магазина"
//         value={values?.name}
//         onChange={(e) => setFieldValue('name', e.target.value)}
//       />
//     </div>
//     <div className="col-12 mt-2">
//       <InputWrapper
//         id="apiToken"
//         label="Токен"
//         value={values?.apiToken}
//         onChange={(e) => setFieldValue('apiToken', e.target.value)}
//       />
//     </div>
//     <div className="col-12 mt-2">
//       <InputWrapper
//         id="extId"
//         label="Внешний код"
//         value={values?.extId}
//         onChange={(e) => setFieldValue('extId', e.target.value)}
//       />
//     </div>
//     <ProductPriceTypeSelect
//       id="priceType"
//       label="Цена товара после скидки"
//       value={values?.priceType}
//       setFieldValue={setFieldValue}
//     />
//     <ProductPriceTypeSelect
//       id="prevPriceType"
//       label="Цена товара до скидки"
//       value={values?.prevPriceType}
//       setFieldValue={setFieldValue}
//     />
//     <div className="col-12 mt-2">
//       <InputWrapper
//         id="percentStock"
//         label="Процент остатков к выгрузке"
//         value={values?.percentStock}
//         onChange={(e) => setFieldValue('percentStock', e.target.value)}
//       />
//     </div>
//     <div className="col-12 mt-2">
//       <InputWrapper
//         id="orderTag"
//         label="Метка на заказы"
//         value={values?.orderTag}
//         onChange={(e) => setFieldValue('orderTag', e.target.value)}
//       />
//     </div>
//     <WarehouseNameSelect value={values?.warehouse} setFieldValue={setFieldValue} />
//     <div className="col-12 mt-2">
//       <InputWrapper
//         id="deliveryInfo"
//         label="Договор доставки"
//         value={values?.deliveryInfo?.name}
//         onChange={(e) =>
//           setFieldValue('deliveryInfo', { ...values.deliveryInfo, name: e.target.value })
//         }
//       />
//     </div>
//   </>
// );

const OzonFields = ({ values, setFieldValue }) => (
  <>
    <MinimumRequiredFieldsToCreateMarketplace values={values} setFieldValue={setFieldValue} />
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiLogin"
        label="Client ID"
        value={values?.apiLogin}
        onChange={(e) => setFieldValue('apiLogin', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiPassword"
        label="API Key"
        value={values?.apiPassword}
        onChange={(e) => setFieldValue('apiPassword', e.target.value)}
      />
    </div>
    <ProductPriceTypeSelect
      id="priceType"
      label="Цена товара после скидки"
      value={values?.priceType}
      setFieldValue={setFieldValue}
    />
    <ProductPriceTypeSelect
      id="prevPriceType"
      label="Цена товара до скидки"
      value={values?.prevPriceType}
      setFieldValue={setFieldValue}
    />
    <div className="col-12 mt-2">
      <InputWrapper
        id="percentStock"
        label="Процент остатков к выгрузке"
        value={values?.percentStock}
        onChange={(e) => setFieldValue('percentStock', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="orderTag"
        label="Метка на заказы"
        value={values?.orderTag}
        onChange={(e) => setFieldValue('orderTag', e.target.value)}
      />
    </div>
    <WarehouseNameSelect value={values?.warehouse} setFieldValue={setFieldValue} />
    <DeliveryContractSelect value={values?.deliveryInfo} setFieldValue={setFieldValue} />
  </>
);

const WBFields = ({ values, setFieldValue }) => (
  <>
    <MinimumRequiredFieldsToCreateMarketplace values={values} setFieldValue={setFieldValue} />
    <div className="col-12 mt-2">
      <InputWrapper
        id="apiToken"
        label="Токен"
        value={values?.apiToken}
        onChange={(e) => setFieldValue('apiToken', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="extId"
        label="ID склада"
        value={values?.extId}
        onChange={(e) => setFieldValue('extId', e.target.value)}
      />
    </div>
    <ProductPriceTypeSelect
      id="priceType"
      label="Цена товара после скидки"
      value={values?.priceType}
      setFieldValue={setFieldValue}
    />
    <ProductPriceTypeSelect
      id="prevPriceType"
      label="Цена товара до скидки"
      value={values?.prevPriceType}
      setFieldValue={setFieldValue}
    />
    <div className="col-12 mt-2">
      <InputWrapper
        id="percentStock"
        label="Процент остатков к выгрузке"
        value={values?.percentStock}
        onChange={(e) => setFieldValue('percentStock', e.target.value)}
      />
    </div>
    <div className="col-12 mt-2">
      <InputWrapper
        id="orderTag"
        label="Метка на заказы"
        value={values?.orderTag}
        onChange={(e) => setFieldValue('orderTag', e.target.value)}
      />
    </div>
    <DeliveryContractSelect value={values?.deliveryInfo} setFieldValue={setFieldValue} />
  </>
);
